import { Link } from "react-router-dom";
import "./cardpodcast.scss";
import { ICardResponse } from "../../../core/models";

export interface ICardPodcastProps {
  props?: ICardResponse;
}

const CardPodcast = ({ props }: ICardPodcastProps) => {
  return (
    <Link
      to={{
        pathname: props?.detailUrl,
      }}
      className="card-podcast"
    >
      <div className="card-podcast__image">
        <img
          src={props?.listImage?.src}
          width={164}
          height={100}
          alt={props?.listImage?.alt}
          style={{ height: "auto", width: "100%" }}
        />
        <span className="icon icon-mic"></span>
        <span className="icon icon-play"></span>
      </div>
      <div className="card-podcast__text">
        <div className="date-container">
          <span className="date">{props?.dateAreaFormatted}</span>
          <span className="time ">{props?.readTime}</span>
          <img src={"/icons/clock.svg"} width={16} height={16} alt="clock" />
        </div>
        <span className="title">
          <strong>{props?.title}</strong>
        </span>
        <span className="icon icon-arrow-right"></span>
      </div>
    </Link>
  );
};

export default CardPodcast;
